import { IonButton, IonImg, IonText } from '@ionic/react';
import classNames from 'classnames';
import { ReactNode } from 'react';

import ModalClose from '@/assets/icons/close.svg';

import styles from './StatusAlert.module.scss';

export interface StatusAlertProps {
  image?: string;
  title: string;
  message: ReactNode;
  actionLabel: string;
  onAction?: () => void;
  onClose?: () => void;
  variant: StatusAlertVariant;
  className?: string;
}
export enum StatusAlertVariant {
  ALERT = 'alert',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
}
export default function StatusAlert({
  image,
  title,
  message,
  actionLabel,
  onAction,
  onClose,
  variant = StatusAlertVariant.ALERT,
  className,
}: StatusAlertProps) {
  return (
    <div
      className={classNames(styles.statusAlert, styles[variant], className)}
      role="alert"
    >
      {image && <IonImg src={image} className={styles.image} />}
      <div className={styles.content}>
        <IonText className={styles.textAlertMovil}>
          {title && <span className={styles.title}>{title}</span>}
          <span className={styles.message}>{message}</span>
        </IonText>
      </div>
      {actionLabel && onAction && (
        <IonButton className={styles.action} onClick={onAction}>
          {actionLabel}
        </IonButton>
      )}
      {onClose && (
        <IonImg src={ModalClose} className={styles.close} onClick={onClose} />
      )}
    </div>
  );
}
